import setAllItemsState from "./setAllItemsState";
import { ITEM_STATE_LOADING } from "../../constants";

export default (state, { payload: { offset, limit } }) => ({
  ...state,
  items: [
    ...state.items.slice(0, offset),
    ...setAllItemsState(
      state.items.slice(offset, offset + limit),
      ITEM_STATE_LOADING
    ),
    ...state.items.slice(offset + limit)
  ]
});
